/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Private_JetInputs */

const en_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Jet`)
};

const es_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jet privado`)
};

const fr_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jet privé`)
};

const de_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatjet`)
};

const ja_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートジェット`)
};

const zh_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私人飞机`)
};

const ar_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طائرة خاصة`)
};

const id_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jet Pribadi`)
};

const it_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jet Privato`)
};

const ru_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частный самолет`)
};

const pt_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jatinho Privado`)
};

const ko_val_private_jet = /** @type {(inputs: Val_Private_JetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인 제트기`)
};

/**
* | output |
* | --- |
* | "Private Jet" |
*
* @param {Val_Private_JetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_private_jet = /** @type {((inputs?: Val_Private_JetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Private_JetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_private_jet(inputs)
	if (locale === "es") return es_val_private_jet(inputs)
	if (locale === "fr") return fr_val_private_jet(inputs)
	if (locale === "de") return de_val_private_jet(inputs)
	if (locale === "ja") return ja_val_private_jet(inputs)
	if (locale === "zh") return zh_val_private_jet(inputs)
	if (locale === "ar") return ar_val_private_jet(inputs)
	if (locale === "id") return id_val_private_jet(inputs)
	if (locale === "it") return it_val_private_jet(inputs)
	if (locale === "ru") return ru_val_private_jet(inputs)
	if (locale === "pt") return pt_val_private_jet(inputs)
	return ko_val_private_jet(inputs)
});